

import category from ".";
import { toggleModal, ADD_SUB_CATEGORY_TO_LIST, UPDATE_SUB_CATEGORY_IN_LIST, DELETE_SUB_CATEGORY_FROM_LIST, ADD_SUB_CATEGORIES_TO_LIST } from "./mutation-types";

export default {

        [toggleModal]: (state, value) =>{
            state.isShowAddOrUpdateModal = value;
        },

        [ADD_SUB_CATEGORIES_TO_LIST]: (state, subCategoriesList=[]) =>{
            subCategoriesList.forEach(item=>{
                if(item.category){
                    item.parentCategory = item.category
                    item.category = item.parentCategory.name
                }
            });
            state.subCategoriesList = subCategoriesList ;
        },
        
        [ADD_SUB_CATEGORY_TO_LIST]: (state, category) =>{
            state.subCategoriesList.push(category);
        },

        [UPDATE_SUB_CATEGORY_IN_LIST]: (state, updatedCategory) =>{
            const index = state.subCategoriesList.findIndex(category => category.id === updatedCategory.id);
            state.subCategoriesList[index] = {...updatedCategory}
        },

        [DELETE_SUB_CATEGORY_FROM_LIST]: (state, categoryIDs) => {
            state.subCategoriesList.forEach((element, index) => { 
                categoryIDs.forEach(id=>{
                     if( id == element.id || id === element.id){
                        state.subCategoriesList.splice(index, 1);
                     }
                        
                });
            });

          },
}
